export const i18nConfig = {
  cookieName: 'i18nextLng',
  defaultLocale: 'en',
  defaultNS: 'tucan',
  locales: ['en', 'de'],
  preload: ['en', 'de'],
  preloadNs: ['tucan', 'common'],
}
